import { useContext } from 'react';
import { AuthenticationContext, User } from './AuthenticationContext';

export function useIsAdmin() {
  const { currentUser } = useContext(AuthenticationContext);
  return currentUser?.isAdmin;
}

export function useIsInternalUser() {
  const { currentUser } = useContext(AuthenticationContext);
  return currentUser?.email.includes('@chronosphere.io');
}

export function useAuth() {
  const auth = useContext(AuthenticationContext);
  return auth;
}

export function useIsServiceAccountUser() {
  const { currentUser } = useContext(AuthenticationContext);
  return currentUser?.email.includes('@serviceaccount.chronosphere.io');
}

/**
 * Hook to get the current user
 */
export function useCurrentUser(): [User | null, boolean] {
  const auth = useAuth();
  const currentUser = (auth.currentUser as User) || null;
  return [currentUser, auth.isLoading];
}

export function useIsAuthenticated() {
  const { currentUser } = useContext(AuthenticationContext);
  return currentUser !== undefined;
}
